






































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ApiPermissions } from '@/core/security/Permissions';
import { RealmApi } from '@/services/api/api.realms';
import { Realm } from '@/types/apiServerContract';

@Component
export default class RunServerScript extends Vue {
	@Prop() realm!: Realm;

	permissions: string[] = [ApiPermissions.Realm.ExecuteServerScripts];
	loading: boolean = false;
	scriptId: number = -1;

	async ExecuteScript() {
	    const check = await this.$bvModal.msgBoxConfirm('Are you sure you wish to execute this serverside script?', {
	        centered: true,
	        okTitle: 'Yes'
	    });
	    if (!check) return;

	    this.loading = true;
	    try {
	        const result = await RealmApi.ExecuteServerScript(this.scriptId);

	        this.$bvToast.toast(result.message, {
	            variant: 'success',
	            title: 'Script Executed'
	        });
	    } finally {
	        this.loading = false;
	    }
	}

	get ServerScripts() {
	    const icons: any[] = [
	        {
	            value: -1,
	            text: 'Select Script'
	        },
	        {
	            value: 1,
	            text: 'Pull Sql Changes',
	            description: 'Pulls all sql files from the github account associated with this realm. A server restart is required afterwards.'
	        }
	    ];
	    return icons;
	}

	Reset() {
	    this.scriptId = -1;
	    (this.$refs as any).Validator.reset();
	}
}
